import { Form } from "@/components/organisms/Form";
import * as yup from "yup";
import { request } from "@/common/api";
import { useForm } from "react-hook-form";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { showAlert } from "@/components/containers/Alert";
import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import { TextControl } from "@/components/containers/Controls/TextControl";
import { BaseResponse } from "@/common/types/baseRespones";
import { FormInputBox } from "@/components/molecules/FormInputBox";
import { SelectControl } from "@/components/containers/Controls/SelectControl";
import { FindAccountTemplate } from "@/components/templates/FindAccountTemplate";
import { useJoinFormHandlers } from "@/common/hooks/useJoinFormHandlers";
import { TelControl } from "@/components/containers/Controls/TelControl";

const schema = yup.object({
  user: yup.object({
    userName: yup.string().required("아이디는 필수 입력입니다."),
    birth: yup
      .date()
      .nullable()
      .optional()
      .typeError("생년월일은 유효한 날짜여야 합니다.")
      .required("생년월일은 필수 입력입니다."),
    tel: yup
      .string()
      .length(
        13,
        "연락처는 000-0000-0000 형식이며, 13자에 맞게 작성하셔야 합니다."
      )
      .required("연락처는 필수 입력입니다."),
  }),
});

export const FindIdPage = () => {
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
  });
  const [findQusetion, setFindQuestion] = useState<string>("");
  const { handleNumberChange } = useJoinFormHandlers();

  const { mutateAsync: findPw } = useMutation({
    mutationFn: (data: { userName: string; birth: Date; tel: string }) => {
      return request<BaseResponse>({
        method: "POST",
        url: "/auth/find-id",
        data,
      });
    },
    onSuccess: (res) => {
      if (!res.success) {
        showAlert(`${res.message}`);
        return;
      }

      navigate("/auth/account/check-id", {
        state: {
          userData: res.data,
        },
      });
    },
  });

  const onSubmit = (data: any) => {
    findPw({
      userName: data.user.userName,
      birth: data.user.birth,
      tel: data.user.tel,
    });
  };

  const formatTelChange = (value: string): string => {
    const numbers = value.replace(/[^0-9]/g, "");

    if (numbers.length < 4) return numbers;
    if (numbers.length < 7) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    if (numbers.length < 11) {
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(
        6
      )}`;
    }
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(
      7,
      11
    )}`;
  };

  return (
    <FindAccountTemplate>
      <>
        <Form
          title="가입정보 입력"
          isFindingAccount={true}
          submitBtn={
            <Buttons
              type="submit"
              size="lg"
              color="primary100"
              layout="solid"
              label="아이디 찾기"
            />
          }
          onSubmit={handleSubmit(onSubmit)}
        >
          <FormInputBox>
            <TextControl
              control={control}
              name="user.userName"
              label="이름"
              placeholder="이름을 입력하세요."
              required={true}
            />
            <TextControl
              control={control}
              type="date"
              name="user.birth"
              label="생년월일"
              placeholder="0000-00-00"
              required={true}
            />
            <TelControl
              type="tel"
              control={control}
              name="user.tel"
              label="연락처"
              placeholder="000-0000-0000"
              required={true}
              onChange={(e) => {
                const formatted = formatTelChange(e.target.value);
                e.target.value = formatted;
              }}
            />
          </FormInputBox>
        </Form>
      </>
    </FindAccountTemplate>
  );
};
